import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import translate from './TranslateHOC';
import { addAddToList, removeAddToList } from '../actions';
import { isInAddToList, addToList, removeFromToList } from '../mys4c_helpers';
import IsLoadingAnim from './alerts/IsLoadingAnim';

import CSSTransitionGroup from 'react-addons-css-transition-group';
import { Button as ButtonV2 } from '../v2/components/button/Button';

function AddToList({
  strings,
  auth,
  id,
  myList,
  dataFor,
  addAddToList,
  removeAddToList,
}) {
  const [localMyList, setLocalMyList] = useState([]);
  const isList = isInAddToList(id, myList);
  const tooltip = isList ? strings.removeFromList : strings.addToList;
  const authClass = auth ? '' : 'hide';

  const toggleProgAddToList = useCallback(
    (e, id, isList) => {
      e.preventDefault();
      if (isList) {
        setLocalMyList(removeFromToList(id, localMyList));
        removeAddToList(id);
      } else {
        setLocalMyList(addToList(id, localMyList));
        addAddToList(id);
      }
    },
    [localMyList, addAddToList, removeAddToList]
  );

  const AddToListTrue = React.memo(({ listText }) => {
    return (
      <ButtonV2
        iconType="material"
        materialLabel="remove_circle_outline"
        icon
        label={listText}
        size="small"
        type="secondary"
      />
    );
  });

  const AddToListFalse = React.memo(({ listText }) => {
    return (
      <ButtonV2
        iconType="material"
        materialLabel="control_point"
        icon
        label={listText}
        size="small"
        type="secondary"
      />
    );
  });

  useEffect(() => {
    setLocalMyList(myList);
  }, [myList]);

  return (
    <>
      {!id ? (
        <IsLoadingAnim classNames="is-loading--large " />
      ) : (
        <li className={authClass}>
          {myList && auth && (
            <CSSTransitionGroup
              onClick={(event) => toggleProgAddToList(event, id, isList)}
              className="link card__favourite-add-to-list"
              transitionName="toggle"
              transitionEnterTimeout={1}
              transitionLeaveTimeout={1}
              data-for={dataFor}
              data-tip={tooltip}
            >
              {isList ? (
                <AddToListTrue listText={tooltip} />
              ) : (
                <AddToListFalse listText={tooltip} />
              )}
              <span className="screen-reader-text">{tooltip}</span>
            </CSSTransitionGroup>
          )}
        </li>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.authenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addAddToList: (id) => dispatch(addAddToList(id)),
    removeAddToList: (id) => dispatch(removeAddToList(id)),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(AddToList)
);
